"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = index;

var _react = _interopRequireDefault(require("react"));

var _Customers = _interopRequireDefault(require("../Business/Customers"));

function index(props) {
  var configuration = props.configuration,
      flexTitle = props.flexTitle;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-customerscase-default-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-customerscase-title-container'
  }, /*#__PURE__*/_react["default"].createElement("span", null, flexTitle)), /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-customerscase'
  }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_Customers["default"], {
      configuration: item,
      key: index
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cust-case-inner-mobile"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cust-case-slider"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cust-case-slider-inner"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "cust-case-slider-scroll"
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "cust-case-slider-list"
  }, configuration === null || configuration === void 0 ? void 0 : configuration.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "cust-case-slider-item",
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_Customers["default"], {
      configuration: item
    }));
  }))))))));
}